import { render, staticRenderFns } from "./importdev.vue?vue&type=template&id=5a28b088&scoped=true"
import script from "./importdev.vue?vue&type=script&lang=js"
export * from "./importdev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28b088",
  null
  
)

export default component.exports